import React from 'react'
import { Form } from 'react-bootstrap'

export default function Number(props) {

    const { label_name, placeholder, name, value,disabled, onChange, onBlur, error } = props

    return (
        <>
            <Form.Group className="mb-2" controlId="text">
                {label_name == '' ? '' : <Form.Label className='form_label'>{label_name}</Form.Label>}
                <Form.Control
                    type="number"
                    placeholder={placeholder}
                    className='config_filed'
                    name={name}
                    disabled={disabled}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                />
                {error}

            </Form.Group>
        </>
    )
}
